import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Alert, Skeleton } from "@akuna/ui";

export interface SectionBoundaryProps {
  isLoading: boolean;
  isError: boolean;
  skeletonClassName?: string;
  children?: ReactNode;
}

/**
 * Guarda de loading/erro compartilhada pelas seções do acompanhamento.
 *
 * Cada seção decide sozinha quando está em loading/erro (podendo combinar
 * mais de uma query com `||`) e chama esta guarda antes de montar o
 * conteúdo que depende dos dados carregados.
 */
export function SectionBoundary({
  isLoading,
  isError,
  skeletonClassName = "h-32 rounded-2xl",
  children = null,
}: SectionBoundaryProps) {
  const { t } = useTranslation("daycareHotel");

  if (isLoading) return <Skeleton className={skeletonClassName} label={t("common.loading")} />;
  if (isError) return <Alert variant="danger">{t("panel.sectionLoadError")}</Alert>;
  return <>{children}</>;
}
